const { createSlice } = require('@reduxjs/toolkit');
const initialState = {
  count: {},
  purposeCard: { dropdownChoice: '', mobileNum: '' },
};
const GroupAdminSlicer = createSlice({
  name: 'GetCount',
  initialState,
  reducers: {
    getNumbersCount: (state, action) => {
      state.count = action.payload;
    },
    setPurposeCard: (state, action) => {
      state.purposeCard = action.payload;
    },
    resetCountState: () => initialState,
  },
});
export const { getNumbersCount, resetCountState, setPurposeCard } =
  GroupAdminSlicer.actions;
export default GroupAdminSlicer.reducer;
